export default "__VITE_ASSET__64105c84__"